<template>
  <el-card class="report-item">
    <div v-if="option">
      <div class="title">
        <div style="display: flex; justify-content: space-between; align-items: center">
          <div v-if="option.title">
            {{ option.title }}
            <template v-if="option.tooltip">
              <el-tooltip class="item" effect="dark" placement="top-start">
                <div slot="content">
                  <div v-html="option.tooltip"></div>
                </div>
                <i class="icon-a-01wenhao iconfont-el icon"></i>
              </el-tooltip>
            </template>
            <slot name="buttons"></slot>
          </div>
          <div style="flex: 1; text-align: end">
            <div class="btns-box" v-if="option.btns">
              <template v-for="(item, index) in option.btns">
                <el-tooltip :disabled="!item.tip" effect="dark" placement="top" :key="index">
                  <div slot="content" v-show="item.tip">
                    <div>{{ item.tip }}</div>
                  </div>
                  <el-button
                    class="btn"
                    type="text"
                    :icon="item.loading ? 'el-icon-loading' : ''"
                    @click="!item.loading && onBtnClick(item)"
                    :title="item.tip"
                  >
                    <i :class="['iconfont', item.icon]" v-if="!item.loading"></i>
                  </el-button>
                </el-tooltip>
              </template>
            </div>
            <span v-if="option.filterTitle">{{ option.filterTitle }}</span>
            <el-select
              class="filter-select"
              v-if="option.filterParam"
              v-model="option.filter"
              :placeholder="option.filterPlaceholder ? option.filterPlaceholder : '请选择'"
              @change="handleFilter"
            >
              <el-option
                v-for="item in option.filterOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <div v-if="option.doubleShaft">
              <el-radio-group v-model="option.doubleShaft" @change="handleFilter">
                <el-radio label="1">单轴</el-radio>
                <el-radio label="2">双轴</el-radio>
              </el-radio-group>
            </div>
          </div>
          <el-date-picker
            v-if="option.timeSelect"
            v-model="timeRange"
            class="filter-select"
            style="width: 250px"
            type="daterange"
            :range-separator="$t('system::time::text::include')"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="handleFilter"
            :picker-options="pickerOptions"
          ></el-date-picker>
          <slot name="customerFilter"></slot>
        </div>
        <slot name="search" :option="option"></slot>
        <div v-if="option.tip" class="tip">{{ option.tip }}</div>
        <slot name="other" :option="option"></slot>
      </div>
      <div class="report-wrap">
        <div
          :ref="option.ref"
          v-show="
            config &&
            config.chart &&
            config.chart.series.length &&
            config.chart.series[0].data &&
            config.chart.series[0].data.length
          "
          :style="`flex:1;height:${option.height};`"
        ></div>
        <defaultData
          :custom="{ height: option.height }"
          v-show="config && config.chart && (!config.chart.series.length || !config.chart.series[0].data.length)"
          style="flex: 1"
        ></defaultData>
        <slot name="reportInfo"></slot>
      </div>
    </div>
  </el-card>
</template>
<script>
import defaultData from '@/components/common/default-data'
import echarts from '../../../../public/js/echart/echarts.min.js'
import echartsJson from '../../../../public/js/echart/customed.json'
import { formatNumberMix, rotateReport } from '@/utils'
import { pickerOptions } from '@/utils/datepickerConfig'
import moment from 'moment'
import { mapState } from 'vuex'
export default {
  name: 'charts',
  components: {
    defaultData,
  },
  props: {
    config: {
      default: () => {},
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        if (this.charts) {
          setTimeout(() => {
            this.charts.resize()
          }, 60)
        }
      })
    })
  },
  computed: {
    ...mapState(['menu']),
  },
  watch: {
    config: {
      handler: function (config) {
        this.option = {
          ...config,
        }
        this.filter = this.option ? this.option.filter : ''
        this.initChart(this.option)
      },
      immediate: true,
      deep: true,
    },
    'menu.collapse': {
      handler: function (val) {
        if (this.charts) {
          setTimeout(() => {
            this.charts.resize()
          }, 60)
        }
      },
    },
  },
  activated() {
    if (this.charts) {
      setTimeout(() => {
        console.log(this.charts, 'this.charts')
        this.charts.resize()
      }, 600)
    }
  },
  data() {
    return {
      resize: null,
      charts: null,
      observer: null,
      pickerOptions,
      filter: '',
      timeRange: [moment().subtract(29, 'days'), moment()],
      filterOptions: [
        // { label: 'utmSource', value: 'utm_source' },
        // { label: 'utmMedium', value: 'utm_medium' },
        // { label: 'utmContent', value: 'utm_content' },
        // { label: 'utmTerm', value: 'utm_term' },
        // { label: 'utmCampaign', value: 'utmCampaign' }
      ],
      option: {},
    }
  },
  methods: {
    initChart(option) {
      setTimeout(() => {
        if (!(option && option.ref)) {
          return
        }
        const refs = this.$refs[option.ref]
        if (!refs) {
          return
        }
        // 指定图表的配置项和数据
        if (!option.chart) {
          return
        }
        if (option.type === 'line') {
          option.chart = this.lineChart(option.chart)
          if (option.doubleShaft && option.doubleShaft === '1') {
            option.chart.yAxis = option.chart.yAxis.slice(0, 1)
            option.chart.series[1].yAxisIndex = 0
          }
        }
        if (option.type === 'lineAndBar') {
          option.chart = this.lineAndBar(option.chart)
        }
        if (option.type === 'bar') {
          option.chart = this.barChart(option.chart)
        }
        if (option.type === 'ring') {
          option.chart = this.ringChart(option.chart)
        }
        if (option.type === 'funnel') {
          option.chart = this.funnelChart(option.chart)
        }

        if (this.charts) {
          this.charts.setOption(option.chart, true)
          this.charts.resize()
          return
        }
        echarts.registerTheme('customed', echartsJson)
        this.charts = echarts.init(refs, 'customed')
        refs.style.height = option.height
        this.charts.setOption(this.$deepClone(option.chart))
        this.charts.resize()
      }, 60)
    },
    onBtnClick(emit) {
      if (emit.link) this.$router.push(emit.link)
      this.$emit('btns', emit)
    },
    ySplitLine() {
      return {
        lineStyle: {
          color: '#999999',
          type: 'dashed',
        },
      }
    },
    gridConfig() {
      return {
        top: '8%',
        left: '3%',
        right: '4%',
        bottom: '12%',
        containLabel: true,
      }
    },
    legendConfig() {
      return {
        left: 'center',
        itemWidth: 12,
        itemHeight: 6,
        bottom: 0,
        itemGap: 24,
      }
    },
    // 双折线
    lineChart(option) {
      if (!option) {
        return {}
      }
      return {
        tooltip: {
          trigger: 'axis',
          ...(option.tooltip ? option.tooltip : {}),
        },
        legend: {
          ...this.legendConfig(),
          data: [],
          ...(option.legend ? option.legend : {}),
        },
        grid: {
          ...this.gridConfig(),
          ...(option.grid ? option.grid : {}),
        },
        xAxis: {
          axisLabel: {
            margin: 16,
            color: '#999999',
            rotate: rotateReport(this, option.xAxis.data || []),
          },
          axisLine: {
            lineStyle: {
              color: '#999999',
            },
          },
          type: 'category',
          boundaryGap: true,
          data: [],
          ...option.xAxis,
        },
        yAxis: option.yAxis
          ? option.yAxis
          : [
              {
                splitLine: this.ySplitLine(),
                axisLabel: {
                  margin: 16,
                  color: '#999999',
                },
                type: 'value',
              },
            ],
        series: option.series ? option.series : [],
      }
    },
    // 折柱混合 line-Bar
    lineAndBar(option) {
      if (!option) {
        return {}
      }
      return {
        tooltip: {
          trigger: 'axis',
          ...(option.tooltip ? option.tooltip : {}),
        },
        legend: {
          ...this.legendConfig(),
          data: [],
          ...(option.legend ? option.legend : {}),
        },
        grid: {
          ...this.gridConfig(),
          ...(option.grid ? option.grid : {}),
        },

        xAxis: {
          type: 'category',
          axisLine: {
            lineStyle: {
              color: '#999999',
            },
          },

          axisLabel: { rotate: rotateReport(this, option.xAxis.data || []), margin: 16, color: '#999999' },
          boundaryGap: true,
          data: [],
          ...(option.xAxis ? option.xAxis : {}),
        },
        yAxis: option.yAxis
          ? option.yAxis
          : [
              {
                type: 'value',
                splitLine: this.ySplitLine(),
                min: 0,
                axisLabel: {
                  margin: 16,
                  color: '#999999',
                },
              },
              {
                type: 'value',
                min: 0,
                splitLine: {
                  show: false,
                },
                axisLabel: {
                  margin: 16,
                  color: '#999999',
                },
              },
            ],
        series: option.series ? option.series : [],
      }
    },
    handleFilter(value) {
      this.$emit('change', value)
    },
    // 柱图
    barChart(option) {
      if (!option) {
        return {}
      }
      return {
        tooltip: {
          trigger: 'axis',
          ...(option.tooltip ? option.tooltip : {}),
        },
        legend: {
          ...this.legendConfig(),
          data: [],
          ...(option.legend ? option.legend : {}),
        },
        grid: {
          top: '4%',
          left: '3%',
          right: '4%',
          bottom: '12%',
          containLabel: true,
        },

        xAxis: {
          type: 'category',
          axisLine: {
            lineStyle: {
              color: '#999999',
            },
          },
          axisLabel: { rotate: rotateReport(this, option.xAxis.data || []), margin: 16, color: '#999999' },
          boundaryGap: true,
          data: [],
          ...option.xAxis,
        },
        yAxis: option.yAxis
          ? option.yAxis
          : [
              {
                type: 'value',
                // name: '水量',
                min: 0,
                splitLine: this.ySplitLine(),
              },
            ],
        series: option.series ? option.series : [],
        boundaryGap: true,
      }
    },
    // 环图
    ringChart(option) {
      if (!option) {
        return {}
      }
      console.log(option)
      return {
        tooltip: {
          trigger: 'item',
          borderColor: '#fff',
          ...(option.tooltip ? option.tooltip : {}),
        },
        legend: {
          bottom: 0,
          left: 'center',
          ...(option.legend ? option.legend : {}),
          // type: 'scroll',
          // orient: 'vertical',
          // right: 0,

          // textStyle: {
          //   width: 100,
          //   overflow: 'break'
          // }
        },
        grid: {
          ...this.gridConfig(),
        },
        graphic: option.graphic ? option.graphic : [],
        series: option.series ? option.series : [],
        color: option.color ? option.color : [],
      }
    },
    // 漏斗
    funnelChart(option) {
      if (!option) {
        return {}
      }
      return {
        tooltip: {
          trigger: 'item',
          borderColor: '#fff',
          ...(option.tooltip ? option.tooltip : {}),
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          right: 0,

          textStyle: {
            width: 100,
            overflow: 'break',
          },
          ...(option.legend ? option.legend : {}),
        },
        grid: {
          ...this.gridConfig(),
        },
        series: option.series ? option.series : [],
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.report-item {
  position: relative;
  margin-top: 18px;
}
.btns-box {
  // position: absolute;
  // right: 0;
  // top: -10px;
  .btn {
    color: #999 !important;
    padding: 0 !important;
  }
  .btn:hover {
    color: #0560fd !important;
  }
}
.icon {
  color: #999;
  margin-left: 5px;
}
.tip {
  margin-top: 4px;
  font-size: 12px;
  color: #999999;
}
.title {
  margin-bottom: 24px;
  position: relative;
  .filter-select {
    width: 150px;
  }
}
.report-wrap {
  display: flex;
  align-items: flex-start;
}
</style>
